import axios from "axios";

// 系统配置
import config from "../configs/config.js";
import aesUtil from "../utils/aesUtil";
// 接口配置文件
let http = {};

// TODO
//  异常处理Function
let errorFunc = function(vm, err) {
  // vm.$U.error(vm, JSON.stringify(err));
  if (err.request.readyState == 4) {
    vm.$U.error(vm, "请求超时！");
    vm.pageObj && vm.pageObj.loading ? (vm.pageObj.loading = false) : false;
    vm.endLoading();
  }
};

// 返回处理
let responseAop = function(vm, response, callback) {
  if (response.data.status == 403) {
    var errMsgObj = response.data.messageList[0];
    vm.$U.error(vm, errMsgObj.messageBody || "token无效！");
    vm.pageObj && vm.pageObj.loading ? (vm.pageObj.loading = false) : false;
    vm.endLoading();
    // vm.$router.push({
    //     name: 'login'
    // });
  } else if (response.data.status !== 200 && response.data.status !== 403) {
    var errMsgObj = response.data.messageList[0];
    vm.$U.error(vm, errMsgObj.messageBody);
    vm.endLoading();
    vm.pageObj && vm.pageObj.loading ? (vm.pageObj.loading = false) : false;
  } else {
    if (response.config.url == "/PILEHOME/api/h5/login") {
      callback(response);
    }else {
      const responseObj = response;
      const encodeMsgList = responseObj.data.messageList;
      const msgObjStr = aesUtil.decrypt(encodeMsgList);
      responseObj.data.messageList = JSON.parse(msgObjStr)
      callback(responseObj);
    }
  }
};

// post请求
http.post = function(vm, url, params, callback) {
  let newPostParams = {};

  if (url == "/PILEHOME/api/h5/login") {
     newPostParams = params
  }else if (url == "PILEHOME/api/h5/bookcharge/delete" || url == "PILEHOME/api/h5/chargehistory/findByNo") {
    const encodeParams = aesUtil.encrypt((params));
     newPostParams = {data:encodeParams};
  } else{
    const encodeParams = aesUtil.encrypt(JSON.stringify(params));
     newPostParams = {data:encodeParams};
  }

  console.log(newPostParams)

  axios
    .post(url, newPostParams, {
      headers: {
        "Content-Type": "application/json",
        authorization: vm.$store.state.token
      },
      timeout: config.httpTimeOut
    })
    .then(response => {
      // if(response.data.status !== 200){
      //     vm.$U.error(vm,response.data.msg);
      //     vm.pageObj.loading = false;
      // }else{
      //     callback(response);
      // }
      responseAop(vm, response, callback);
    })
    .catch(error => {
      errorFunc(vm, error);
      console.log(error);
    });
};

// post请求
http.postFile = function(vm, url, params, callback) {
  axios
    .post(url, params, {
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: vm.$store.state.token
      },
      timeout: config.httpTimeOut
    })
    .then(response => {
      // if(response.data.status !== 200){
      //     vm.$U.error(vm,response.data.msg);
      //     vm.pageObj.loading = false;
      // }else{
      //     callback(response);
      // }
      responseAop(vm, response, callback);
    })
    .catch(error => {
      errorFunc(vm, error);
      console.log(error);
    });
};

// get请求
http.get = function(vm, url, params, callback) {
  console.log(params)
  axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
        authorization: vm.$store.state.token
      },
      params: params,
      timeout: config.httpTimeOut
    })
    .then(response => {
      // if(response.data.status !== 200){
      //     vm.$U.error(vm,response.data.msg);
      //     vm.pageObj.loading = false;
      // }else{
      //     callback(response);
      // }

      responseAop(vm, response, callback);
    })
    .catch(error => {
      errorFunc(vm, error);
      console.log(error);
    });
};

// delete
http.delete = function(vm, url, callback) {
  axios
    .delete(url, {
      timeout: config.httpTimeout,
      headers: {
        authorization: vm.$store.state.token
      }
    })
    .then(function(response) {
      // if(response.data.status !== 200){
      //     vm.$U.error(vm,response.data.msg);
      //     vm.pageObj.loading = false;
      // }else{
      //     callback(response);
      // }

      responseAop(vm, response, callback);
    })
    .catch(function(error) {
      errorFunc(vm, error);
      console.log(error);
    });
};

// put
http.put = function(vm, url, params, callback) {
  axios
    .put(url, params, {
      headers: {
        "Content-Type": "application/json",
        authorization: vm.$store.state.token
      },
      timeout: config.httpTimeout
    })
    .then(function(response) {
      // if(response.data.status !== 200){
      //     vm.$U.error(vm,response.data.msg);
      //     vm.pageObj.loading = false;
      // }else{
      //     callback(response);
      // }

      responseAop(vm, response, callback);
    })
    .catch(function(error) {
      errorFunc(vm, error);
      console.log(error);
    });
};

// put
http.patch = function(vm, url, params, callback) {
  axios
    .patch(url, params, {
      headers: {
        "Content-Type": "application/json",
        authorization: vm.$store.state.token
      },
      timeout: config.httpTimeout
    })
    .then(function(response) {
      // if(response.data.status !== 200){
      //     vm.$U.error(vm,response.data.msg);
      //     vm.pageObj.loading = false;
      // }else{
      //     callback(response);
      // }

      responseAop(vm, response, callback);
    })
    .catch(function(error) {
      errorFunc(vm, error);
      console.log(error);
    });
};

export default http;



// WEBPACK FOOTER //
// ./src/utils/httpUtils.js